export default {
  categoryCodes: [],
};
